import { BUTTER, CORAL, INK, LILAC, MINT, PAPER, PEACH, SHAPE_COLORS, SKY, lerpColor } from '../../color';
import type { World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const world: World = {
  id: 'caderno',
  name: 'Caderno',
  seed: 'a',
  legacy: true,
  hue: 37,
  ceil: PAPER,
  font: 'Shantell Sans',
  fontFile: 'shantell-sans-800.woff2',
  fontWeight: '800',
  fontLicense: 'OFL-1.1',
  dark: false,
  boil: true,
  glow: 'normal',
  glowAlpha: 0.3,
  fillAlpha: 0.62,
  palette: {
    bg: PAPER,
    ink: INK,
    rim: PAPER,
    held: PEACH,
    heldShade: CORAL,
    heldLight: lerpColor(PEACH, PAPER, 0.6),
    incoming: SHAPE_COLORS,
    spot: INK,
    path: INK,
    text: INK,
    sparks: [BUTTER, CORAL, SKY, MINT, LILAC],
  },
  burst: { count: 12, speed: 0.5, drag: 3.5, gravity: 0.35, spin: 5, life: 0.9, sizeMin: 0.012, sizeMax: 0.024 },
  dress,
  fx,
  paint,
};

export default world;
